module.exports = __webpack_public_path__ + "static/media/July.2024 Dai Hung - Block 05.1a.9123591d.pdf";